import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {GradeToString} from "../students/list";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AddEditClassModal = (props:{active:boolean,closeHandler:any,onDone:any,isEdit:boolean,classId:string}) => {
    const [title,setTitle] = useState('');
    const [grade,setGrade] = useState('1');
    const [err,setErr] = useState({
       title:false,
       grade:false,
    });
    const ids = {
        title:useId(),
        grade:useId(),
    };
    const fetchData = () => {
        ShowProgressLoading();
        const classId = props.classId;
        PostJSON(
            Apis.server + '/core/admins/class/get-single',
            {id:classId},
            true,
            (d: { 
                result:string,
                reason:string|undefined,
                title:string,
                grade:number,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    else 
                        props.closeHandler();
                    return;
                }
                setTitle(d.title);
                setGrade(d.grade.toString());
            },
            ()=>{
                HideProgressLoading();
                props.closeHandler();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.isEdit;
        if(isActive){
            document.body.classList.add('body-no-scroll');
            setTitle('');
            setGrade('1');
            if(isEdit)
                fetchData();
            setErr({
               title: false,
               grade: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active, props.isEdit]);
    const saveChanges = () => {
        const isEdit = props.isEdit;
        const classId = props.classId;
        const _title = title.trim();
        const _grade = parseInt(grade === '' ? '0' : grade) as number | string;
        let error = {
            title:false,
            grade:false,
        };
        let stop = false;
        if(_title.length < 1){
            stop = true;
            error.title = true;
        }
        if (_grade < 1 || _grade > 12) {
            stop = true;
            err.grade = true;
        }
        setErr(error);
        if(stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/class/' + (isEdit ? 'edit':'add'),
            {
                id:classId,
                title:_title,
                grade:_grade.toString(),
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                props.onDone();
                ShowSnackbar(
                    isEdit ? 'ویرایش کلاس انجام شد.' : 'کلاس جدید ذخیره شد.',
                    'باشه',
                    5000,
                );
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active':'')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div>
                        <b>{props.isEdit ? 'ویرایش کلاس' : 'کلاس جدید'}</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={ids.title}>نام کلاس:</label>
                        <input type="text"
                               id={ids.title}
                               className={"form-control" + (err.title ? ' is-invalid' : '')}
                               value={title}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTitle(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.title = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback " + (err.title ? 'd-block' : 'd-none')}>
                            لطفا این سطر را تکمیل کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.grade}>پایه تحصیلی:</label>
                        <select id={ids.grade}
                                value={grade}
                                className={"form-control" + (err.grade ? ' is-invalid' : '')}
                                onChange={e => {
                                    let t = e.currentTarget.value;
                                    setGrade(t);
                                    setErr(v => {
                                        let x = {...v};
                                        x.grade = false;
                                        return x;
                                    });
                                }}>
                            {
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((g, i) =>
                                    <option key={"Ksj39fnd" + i} value={g.toString()}>
                                        {GradeToString(g)}
                                    </option>
                                )
                            }
                        </select>
                        <div
                            className={"invalid-feedback " + (err.grade ? 'd-block' : 'd-none')}>لطفا
                            یک
                            پایه تحصیلی را انتخاب کنید.
                        </div>
                        <div style={{height: 40}}/>
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};